import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, Input, Label, FormGroup } from "reactstrap";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import Handler from "../../Helpers/Handler";
import { toast } from "react-toastify";

const PaymentModal = ({ isOpen, toggle, invoiceData, onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState({
        amount: "",
        payment_date: dayjs(),
        payment_method: "Cash",
        reference_number: ""
    });

    // ⭐ Universal Balance Logic: Row data-la irunthu vara keys-ah sariya eduthukkom
    const totalAmount = parseFloat(invoiceData?.invoice_total || invoiceData?.total_amount || 0);
    const paidAmount = parseFloat(invoiceData?.total_paid || invoiceData?.paid_amount || 0);
    
    console.log("Invoice Data:", invoiceData);

    // Remaining balance direct-ah vantha athai edukum, illana manual calculation
    const balanceValue = invoiceData?.remaining_balance !== undefined 
        ? parseFloat(invoiceData.remaining_balance) 
        : (totalAmount - paidAmount);

    const balance = balanceValue.toFixed(2);

    useEffect(() => {
        if (isOpen) {
            setForm({ 
                amount: balance, 
                payment_date: dayjs(), 
                payment_method: "Cash", 
                reference_number: "" 
            });
        }
    }, [isOpen, balance]);

    const handleSubmit = async () => {
        const inputAmount = parseFloat(form.amount);
        const currentBalance = parseFloat(balance);

        // ⭐ ERROR FIX: Amount balance-vida PERUSA iruntha thaan error kaattanum
        if (!form.amount || inputAmount <= 0) {
            return toast.error("Enter valid amount");
        }
        
        if (inputAmount > currentBalance) { // <--- Ippo correct-ah work aagum machan
            return toast.error(`Amount exceeds balance (Max: SGD ${currentBalance.toFixed(2)})`);
        }
        
        if (form.payment_method === "PayNow" && !form.reference_number) {
            return toast.warning("Please enter PayNow Transaction ID in Ref No");
        }

        setLoading(true);
        const res = await Handler({
            method: "post",
            url: "/payments/create.php",
            data: {
                customer_id: invoiceData.customer_id,
                invoice_id: invoiceData.invoice_id || invoiceData.id, 
                amount: form.amount,
                payment_date: dayjs(form.payment_date).format("YYYY-MM-DD"),
                payment_method: form.payment_method,
                reference_number: form.reference_number
            }
        });
        setLoading(false);

        if (res?.success) {
            toast.success("Payment Recorded!");
            if (onSuccess) onSuccess(); 
            toggle();
        } else {
            toast.error(res?.message || "Payment Failed");
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Modal isOpen={isOpen} toggle={toggle} centered backdrop="static">
                <ModalHeader toggle={toggle} className="fw-bold">
                    Add Payment for {invoiceData?.invoice_number || `INV-${invoiceData?.invoice_id || invoiceData?.id}`}
                </ModalHeader>
                <ModalBody>
                    <div className="bg-light p-3 rounded mb-3 border">
                        <div className="d-flex justify-content-between mb-1">
                            <span className="text-muted">Total Amount:</span> 
                            <b className="text-dark">SGD {totalAmount.toFixed(2)}</b>
                        </div>
                        <div className="d-flex justify-content-between">
                            <span className="text-muted">Balance Due:</span> 
                            <b className="text-danger">SGD {balance}</b>
                        </div>
                    </div>
                    
                    <Row className="g-3">
                        <Col md={12}>
                            <FormGroup>
                                <Label className="small fw-bold text-uppercase">Payment Amount (SGD)</Label>
                                <Input 
                                    type="number" 
                                    value={form.amount} 
                                    onChange={(e) => setForm({...form, amount: e.target.value})} 
                                />
                            </FormGroup>
                        </Col>
                        <Col md={12}>
                            <FormGroup>
                                <Label className="small fw-bold text-uppercase">Payment Date</Label>
                                <DatePicker 
                                    slotProps={{ textField: { size: 'small', fullWidth: true } }}
                                    value={form.payment_date}
                                    onChange={(val) => setForm({...form, payment_date: val})}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label className="small fw-bold text-uppercase">Method</Label>
                                <Input type="select" value={form.payment_method} onChange={(e) => setForm({...form, payment_method: e.target.value})}>
                                    <option value="Cash">Cash</option>
                                    <option value="Bank Transfer">Bank Transfer</option>
                                    <option value="Cheque">Cheque</option>
                                    <option value="PayNow">PayNow</option>
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label className="small fw-bold text-uppercase">Ref No / Trans ID</Label>
                                <Input 
                                    placeholder={form.payment_method === "PayNow" ? "Transaction ID" : "Check/Ref No"}
                                    value={form.reference_number} 
                                    onChange={(e) => setForm({...form, reference_number: e.target.value})} 
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter className="border-0">
                    <Button color="secondary" outline onClick={toggle} className="px-4">Cancel</Button>
                    <Button color="success" disabled={loading} onClick={handleSubmit} className="px-4">
                        {loading ? "Recording..." : "Confirm Payment"}
                    </Button>
                </ModalFooter>
            </Modal>
        </LocalizationProvider>
    );
};

export default PaymentModal;